const sand = {
  sand1: "hsl(50, 20.0%, 99.0%)",
  sand2: "hsl(60, 7.7%, 97.5%)",
  sand3: "hsl(59, 6.5%, 95.1%)",
  sand4: "hsl(58, 6.1%, 92.9%)",
  sand5: "hsl(57, 6.0%, 90.7%)",
  sand6: "hsl(56, 5.9%, 88.4%)",
  sand7: "hsl(55, 5.9%, 85.2%)",
  sand8: "hsl(51, 6.0%, 77.1%)",
  sand9: "hsl(50, 2.0%, 55.7%)",
  sand10: "hsl(55, 1.7%, 51.9%)",
  sand11: "hsl(50, 2.0%, 43.1%)",
  sand12: "hsl(50, 6.0%, 10.0%)"
};
export { sand };
//# sourceMappingURL=sand.mjs.map
